var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { GeneralScoreboard } from "../GeneralScoreboard";
var Tennis = /** @class */ (function (_super) {
    __extends(Tennis, _super);
    function Tennis(props) {
        return _super.call(this, props) || this;
    }
    Tennis.prototype.renderTableScoreInformation = function (scoreInfo) {
        return scoreInfo.map(function (item, index) {
            return React.createElement("td", { key: index, className: "rj-tscoreboard__score-info" }, item);
        });
    };
    Tennis.prototype.renderTableTotalInformation = function (totalInfo) {
        return React.createElement("td", { className: "rj-tscoreboard__total-info" }, totalInfo);
    };
    Tennis.prototype.render = function () {
        return (React.createElement("table", { className: "rj-tscoreboard" + (this.props.modifier ? " rj-tscoreboard--" + this.props.modifier : "") },
            React.createElement("tbody", null,
                React.createElement("tr", { className: "rj-tscoreboard__players" },
                    this.renderTableScoreInformation(this.props.scoreFirstPlayer),
                    this.renderTableTotalInformation(this.props.totalFirstPlayer)),
                React.createElement("tr", { className: "rj-tscoreboard__players" },
                    this.renderTableScoreInformation(this.props.scoreSecondPlayer),
                    this.renderTableTotalInformation(this.props.totalSecondPlayer)))));
    };
    return Tennis;
}(GeneralScoreboard));
export { Tennis };
//# sourceMappingURL=Tennis.js.map